import 'ui-core/plugins/scrollo/js/scrollo';
import {fixedHeaderHeight} from 'ui-core/utility/js/utils';

UX.scrollo.control = function () {
    var $body = $('body');
    var $anchors =
        'a[href^=\'#\'], a.table-fn[href^="#"]:not(.coolBar__ctrl), a.ref.fn[href^="#"]:not(.coolBar__ctrl), .scroll-to-target a[href^="#"]:not(.coolBar__ctrl), .article__content a[href^="#"]:not(.coolBar__ctrl)';
    $body.on('click', $anchors, function (e) {
        if (
            $(this).attr('href') != '#' && // eslint-disable-line
            ($('.article__body ' + $(this).attr('href')).length > 0 ||
                $('.toc_content ' + $(this).attr('href')).length > 0)
        ) {
            e.preventDefault();
            UX.scrollo.adjustAnchor(e);
            return false;
        }
    });
    $body.on('click keydown', 'a[href^="#"].sr-only-focusable', function (e) {
        // pass click and ENTER to action
        if (e.keyCode && e.keyCode !== 13) {
            return;
        }
        if (window.location.hash === $(this).attr('href')) {
            UX.scrollo.adjustAnchor(e);
        }
    });
    $body.on('click', '.w-slide__back', function () {
        if ($('[data-scroll-back-to]').length) {
            $(document).scrollTop($('[data-scroll-back-to]').data('scroll-back-to'));
            $('[data-scroll-back-to]').removeAttr('data-scroll-back-to');
        }
    });
};

UX.scrollo.adjustAnchor = function (e) {
    var $anchor = $(e.currentTarget.hash);
    var fixedElementsHeight = fixedHeaderHeight() + $('.coolBar').outerHeight();
    e.preventDefault();

    if ($anchor.length > 0) {
        e.stopPropagation();
        // When we prevent default, we have to also change focus to target manually
        $anchor.eq(0).focus();
        window.scrollTo(0, UX.scrollo.offset($anchor.get(0)).top - fixedElementsHeight);
    }
};
